import { render } from "./UpcomingPage.vue?vue&type=template&id=66bc94f6"
import script from "./UpcomingPage.vue?vue&type=script&lang=js"
export * from "./UpcomingPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__